import { render, staticRenderFns } from "./CategoryTabs.vue?vue&type=template&id=00282c87&scoped=true&"
import script from "./CategoryTabs.vue?vue&type=script&lang=js&"
export * from "./CategoryTabs.vue?vue&type=script&lang=js&"
import style0 from "./CategoryTabs.vue?vue&type=style&index=0&id=00282c87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00282c87",
  null
  
)

export default component.exports